// Pathify
import Vue from 'vue'
import { dispatch, make } from 'vuex-pathify'
import axios from 'axios'
import router from '@/router'

Vue.use(router)

// Data
const state = {
  reports: [
    {
      name: 'company-authorization',
      file_name: 'CompanyAuthorization',
    },
    {
      name: 'rental-agreement',
      file_name: 'RentalAgreement',
    },
    {
      name: 'operating-day-summary',
      file_name: 'OperatingDaySummary',
    },
    {
      name: 'user-training-report',
      file_name: 'UserTrainingReport',
    },
    {
      name: 'aszf-pdf',
      file_name: 'ASZF',
    },
    {
      name: 'help-pdf',
      file_name: 'CumuluslogManual',
    },
    {
      name: 'component-list',
      file_name: 'Component-list',
    },
    {
      name: 'plane-document-package',
      file_name: 'PlaneDocumentPackage',
    },
    {
      name: 'airport-use-license',
      file_name: 'AirportUseLicences',
    },
  ],
}

const mutations = {
  ...make.mutations(state),
}

const actions = {
  ...make.actions(state),
  init: async ({ dispatch }) => {
  },

  getReport (context, payload) {
    state.loading = true
    const report = state.reports.filter(f => f.name === payload.type)
    return new Promise((resolve, reject) => {
      axios.post('/api/report/' + payload.type, payload, { responseType: 'blob' })
        .then((response) => {
          var fileURL = window.URL.createObjectURL(new Blob([response.data]))
          var fileLink = document.createElement('a')
          fileLink.href = fileURL
          const extension = payload.extension ?? 'pdf'
          fileLink.setAttribute('download', report[0].file_name + '-' + payload.source_name + '.' + extension)
          document.body.appendChild(fileLink)
          fileLink.click()
          state.loading = false
        }).catch(error => {
        dispatch('alert/setSnackbar', { text: error, type: 'error' })
        reject(error)
        state.loading = false
      })
    })
  },
  accept (context, payload) {
    return new Promise((resolve, reject) => {
      axios.post('/api/action/accept', payload)
        .then(result => {
          resolve(result.data)
        }).catch(error => {
        if (error.response.status === 422) {
          reject(error.response.data.errors)
        }
        reject(error)
      })
    })
  },
  organizationUserInvitation (context, payload) {
    return new Promise((resolve, reject) => {
      axios.post('/api/action/organization-user-invitation', payload)
        .then(result => {
          resolve(result.data)
        }).catch(error => {
        console.log(error)
        if (error.response.status === 422) {
          reject(error.response.data.errors)
        }
        reject(error)
      })
    })
  },
  userOrganizationApply (context, payload) {
    return new Promise((resolve, reject) => {
      axios.post('/api/action/user-organization-apply', payload)
        .then(result => {
          resolve(result.data)
        }).catch(error => {
        if (error.response.status === 422) {
          reject(error.response.data.errors)
        }
        reject(error)
      })
    })
  },
  userOrganizationGuestApply (context, payload) {
    return new Promise((resolve, reject) => {
      axios.post('/api/action/user-organization-guest-apply', payload)
        .then(result => {
          resolve(result.data)
        }).catch(error => {
        if (error.response.status === 422) {
          reject(error.response.data.errors)
        }
        reject(error)
      })
    })
  },
  planeMaintenancerApply (context, payload) {
    return new Promise((resolve, reject) => {
      axios.post('/api/action/plane-maintenancer-apply', payload)
        .then(result => {
          resolve(result.data)
        }).catch(error => {
        if (error.response.status === 422) {
          reject(error.response.data.errors)
        }
        reject(error)
      })
    })
  },
  shareTrainingRequest (context, payload) {
    return new Promise((resolve, reject) => {
      axios.post('/api/action/share-training-request', payload)
        .then(result => {
          resolve(result.data)
        }).catch(error => {
        if (error.response.status === 422) {
          reject(error.response.data.errors)
        }
        reject(error)
      })
    })
  },
  substitutionRequest (context, payload) {
    return new Promise((resolve, reject) => {
      axios.post('/api/action/substitution-request', payload)
        .then(result => {
          resolve(result.data)
        }).catch(error => {
        if (error.response.status === 422) {
          reject(error.response.data.errors)
        }
        reject(error)
      })
    })
  },
  deductionMembershipFee (context, payload) {
    return new Promise((resolve, reject) => {
      axios.post('/api/action/deduction-membership-fee', payload)
        .then(result => {
          resolve(result.data)
        }).catch(error => {
        reject(error)
      })
    })
  },
}

const getters = {}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
